/* Susur — overlay nav helpers.
   1) Publishes the live header + announcement-bar heights as CSS vars so the
      hero can tuck itself perfectly under the transparent nav.
   2) Drives the semi-sticky behaviour on the homepage overlay nav:
      transparent at the very top, slides away as you scroll down, and quickly
      reappears pinned with a frosted backdrop the moment you scroll up. */
(function () {
  var docEl = document.documentElement;

  function measure() {
    // the nav wrapper is position:fixed, so the .section-header it sits in
    // collapses to 0 — measure the nav element itself.
    var nav = document.querySelector('.susur-header--overlay');
    var sec = document.querySelector('.section-header');
    var h = nav ? nav.offsetHeight : (sec ? sec.offsetHeight : 0);
    if (h) {
      docEl.style.setProperty('--susur-header-h', h + 'px');
      docEl.style.setProperty('--header-height', h + 'px');
    }
    var ann = document.querySelector('.announcement-bar') || document.querySelector('.utility-bar');
    docEl.style.setProperty('--susur-ann-h', (ann ? ann.offsetHeight : 0) + 'px');
  }

  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(measure); }
  setTimeout(measure, 500);

  var header = document.querySelector('.susur-header--overlay');
  if (!header) return;

  var TOP = 8;            // treat anything within 8px of the top as "at the top"
  var DELTA = 6;          // ignore micro-jitters / rubber-banding
  var lastY = window.pageYOffset || docEl.scrollTop;
  var ticking = false;

  function update() {
    var y = window.pageYOffset || docEl.scrollTop;

    if (y <= TOP) {
      // back at the top — restore the transparent overlay look
      header.classList.remove('is-pinned', 'is-hidden');
    } else if (Math.abs(y - lastY) > DELTA) {
      if (y > lastY && y > header.offsetHeight) {
        // scrolling down, past the header — pin then slide it away
        header.classList.add('is-pinned', 'is-hidden');
      } else if (y < lastY) {
        // scrolling up — reveal it pinned with the frosted backdrop
        header.classList.add('is-pinned');
        header.classList.remove('is-hidden');
      }
    }

    lastY = y;
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
